import {
    BrandStrollersListState,
    BrandsStrollersListState,
} from "@/mk2/apps/strollers/containers/BrandsStrollersList/BrandsStrollersList.reducers";
import { LoadingState } from "@/mk2/reducers/loadingState";

export const initialBrandStrollersListState: BrandStrollersListState = {
    strollerIds: [],
    strollersPreviewPhotoMap: {},
    strollersPhotosIds: [],
    loadingState: LoadingState.INIT,
    errorMessage: null,
    hasMore: false,
    count: null,
    brandId: null,
    articleIds: [],
};

export const initialBrandsStrollersListState: BrandsStrollersListState = {
    brands: {},
    buyingGuideId: null,
    counsellingId: null,
    forumPostLinkedObjects: null,
};
